import { useFormat } from '@ideavivat/vivat-2';

import {
  _increment,
} from '@/table/Job/SubJob/base';
import usePurchaseRequest from '@/use/usePurchaseRequest';
import {
  materialBrand, bom_item, type, purchase_request,
} from './base';

const { typeTranslate } = usePurchaseRequest();

export default {
  types: {
    _selectorControls: {
      width: '2rem',
      class: 'text-center',
    },
    _increment,
    purchase_request,
    type,
    subType: {
      name: '',
      width: '6rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => {
        if (row.item.purchase_request?.subType) return typeTranslate(row.item.purchase_request?.subType);
        return '';
      },
    },
    bom_item,
    material: {
      name: 'รหัสชิ้นส่วน',
      width: '12rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => {
        if (row.item.bom_item?.production_type === 'FAB') return row.item.bom_item?.drawing_no;
        return row.item.material?.code;
      },
    },
    description: {
      name: 'รายละเอียด',
      width: '1fr',
      filter: (val: string, row: any) => row.item.bom_item?.description || '',
    },
    materialBrand,
    amount: {
      name: 'จำนวนที่ต้องการ / ซื้อแล้ว',
      width: '10rem',
      class: 'text-right',
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    unit: {
      name: 'หน่วย',
      width: '5rem',
      class: 'text-left',
      filter: (val: string, row: any) => row.item.material?.unit || '',
    },
    target_date: {
      name: 'วันที่ต้องการ',
      width: '8rem',
      class: 'text-center',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : 'ไม่ระบุ',
    },
  },
};
